import { z } from "zod";
import { Point } from "../../data/types/point.type";

interface UseCase {
  id: string;
  name: string;
}

interface User {
  id: string;
  firstName: string;
  lastName: string;
}

export interface Dropzone {
  points: Point[];
  backgroundColor: string;
}

export interface Context {
  id: string;
  name: string;
  filename: string;
  user: User;
  imageUrl: string;
  scaledUrl: string;
  scaledWithDropzoneUrl: string;
  thumbUrl: string;
  thumbWithDropzoneUrl: string;
  width: number;
  height: number;
  aspectRatio: number;
  sizeInBytes: number;
  dropzone: Dropzone;
  useCase: UseCase;
  isArchived: boolean;
  createdAt: string;
  createdAtTimeStamp: number;
  updatedAt: string;
  updatedAtTimeStamp: number;
}

export interface ContextPack {
  id: string;
  name: string;
  useCase: UseCase;
  firstContextId: string;
  // isClone: boolean;
  isDragonfly: boolean;
  username: string;
  isArchived: boolean;
  isPublished: boolean;
  contextCount: number;
  createdAt: string;
  updatedAt: string;
  contexts: Context[];
}

export interface ContextProcessAsset {
  label: string;
  imageUrl: string;
  zone: Dropzone[];
}

export interface ContextInsight {
  key: string;
  label: string;
  imageUrl: string;
  las: number;
  pop: number;
  pow: number;
  soa: number;
  vis: number;
  zone: Dropzone[];
}

/* Schema */
export const createContextPackSchema = z.object({
  name: z
    .string()
    .min(1, "Context title is required")
    .max(255, "Context title must be 255 characters or less")
    .refine((val) => val.trim().length > 0, "Context title is required"),
  useCaseId: z.string(),
  useCaseName: z.string(),
});

export const archiveContextPackSchema = z.object({
  isArchived: z.boolean(),
});
